// extracted by mini-css-extract-plugin
export default {"dropdown__section":"styles_dropdown__section__DiRKu"};